import { Divider, Grid, styled } from "@mui/material";
import { IS_MOBILE } from "../../../constants/breakpoints";

//import general components
import ArrowIcon from "../arrow-icon/arrow-icon";

//import images and icons
import { ArrowDown2, ArrowUp2 } from "iconsax-react";

//import styles
import "./recommend-divider.scss";

function RecommendDivider({ children, title, handleClick, isExpanded }) {
    //divider styles
    const Root = styled("div")(({ theme }) => ({
        width: "100%",
        fontSize: "1.5rem",
        "& > :not(style) ~ :not(style)": {
            marginTop: theme.spacing(2),
        },
        "& .MuiDivider-root": {
            "&:before": {
                borderTop: "2px solid var(--secondary-color)",
            },
            "&:after": {
                borderTop: "2px solid var(--secondary-color)",
            },
        },
        "& .MuiDivider-wrapper": {
            fontSize: "1.5rem",
            color: "var(--secondary-color)",
            [theme.breakpoints.between("lg", "xl")]: {
                fontSize: "1.25rem",
            },
            [theme.breakpoints.between("xs", "md")]: {
                fontSize: "0.875rem",
                color: "var(--light-color)",
            },
        },
    }));

    return (
        <>
            {IS_MOBILE ? (
                <>
                    <Grid
                        className="recommended-divider__title"
                        container
                        item
                        xs={12}
                        columnGap={{ xs: 1, md: 0 }}
                        alignItems="center"
                        mx={{ xs: "16px", md: 0 }}
                        onClick={handleClick}
                    >
                        <ArrowIcon icons={[ArrowDown2, ArrowUp2]} isExpanded={isExpanded} size="16" color="var(--light-color)" />
                        <span>{title}</span>
                    </Grid>
                    {children}
                </>
            ) : (
                <>
                    <Root>
                        <Divider>{title}</Divider>
                    </Root>
                    {children}
                    <Divider sx={{ width: "100%", borderBottom: "2px solid var(--secondary-color)" }} />
                </>
            )}
        </>
    );
}

export default RecommendDivider;
